import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function HolidayVillageIcon(props: IconProps) {
    return <Icon {...props} iconKey={"holiday_village"}/>
}
